import { FormEvent, useContext, useEffect, useRef, useState } from "react"
import { FAQContext, FAQContextType } from "../provider/FAQProvider";

export default function FAQSearchBox() {
  const { searchTerm, termSetter } = useContext(FAQContext) as FAQContextType;
  const searchBox = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (searchBox.current) {
      searchBox.current.value = searchTerm;
      searchBox.current.focus();
    }
  }, [])

  const onFormSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    termSetter(searchBox.current?.value ?? '');
  };

  return (
    <div className="search-box">
      <form className="searchbox-form"
        onSubmit={onFormSubmit}>
        <input type="text" className="form-control" placeholder="Search..." ref={searchBox} />
        <button type='submit'><span className="fa fa-search" aria-hidden="true"></span></button>
      </form>
    </div>
  )
}